import { render } from "./ServiceContactSection.vue?vue&type=template&id=3db395bb&scoped=true"
import script from "./ServiceContactSection.vue?vue&type=script&lang=js"
export * from "./ServiceContactSection.vue?vue&type=script&lang=js"

import "./ServiceContactSection.vue?vue&type=style&index=0&id=3db395bb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3db395bb"]])

export default __exports__